/**
 * Legacy Al-Amir staff used usernames. Lumora users are email-keyed.
 * Map username → synthetic site email (and pass through real emails).
 */
export function resolveStaffLoginEmail(raw: string): string {
  const id = raw.trim();
  if (!id) return "";
  if (id.includes("@")) return id.toLowerCase();
  return `${id.toLowerCase()}@alamirauto.com`;
}

const STORAGE_KEY = "alamir.staffUser";

/** Staff identity for the session VM: usernames map to site emails and live in sessionStorage. */
export const sessionStaffIdentity = {
  resolveEmail: resolveStaffLoginEmail,
  remember(username: string): void {
    try {
      if (typeof sessionStorage !== "undefined" && username) sessionStorage.setItem(STORAGE_KEY, username);
    } catch {
      // storage unavailable
    }
  },
  recall(): string {
    try {
      return typeof sessionStorage !== "undefined" ? sessionStorage.getItem(STORAGE_KEY) || "" : "";
    } catch {
      return "";
    }
  },
  forget(): void {
    try {
      if (typeof sessionStorage !== "undefined") sessionStorage.removeItem(STORAGE_KEY);
    } catch {
      // storage unavailable
    }
  },
};
